/* @flow */

import * as React from 'react';
import { translate } from 'react-i18next';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

@translate()
export default class CostCenterDetails extends React.Component<*> {
  render(): React.Element<*> {
    const t: Function = this.props.t;
    const details: any = this.props.details;

    const getChildData: Function = (child: string, val: string) => {
      return typeof details[child] === 'undefined' ? null : details[child][val];
    };

    return (
      <React.Fragment>
        <h3>{t('general:cost_centers.labels.details')}</h3>
        <table>
          <tbody>
            <tr>
              <td>
                <b>{t('general:trading_accounts.labels.name')}:</b>
              </td>
              <td>{getChildData('trading_account', 'name')}</td>
            </tr>
            <tr>
              <td>
                <b>{t('general:trading_accounts.labels.number')}:</b>
              </td>
              <td>{getChildData('trading_account', 'account_no')}</td>
            </tr>
            <tr>
              <td>
                <b>{t('general:cost_centers.labels.name')}:</b>
              </td>
              <td>{details.name}</td>
            </tr>
            <tr>
              <td>
                <b>{t('general:cost_centers.labels.code')}:</b>
              </td>
              <td>{details.code}</td>
            </tr>
            <tr>
              <td>
                <b>{t('general:cost_centers.labels.description')}:</b>
              </td>
              <td>{details.description}</td>
            </tr>
          </tbody>
        </table>
      </React.Fragment>
    );
  }
}
